import { BreadcrumbItem as _BreadcrumbItem, BreadcrumbItemProps as _BreadcrumbItemProps } from "reactstrap";

    export const BreadcrumbItem = _BreadcrumbItem;
    export type BreadcrumbItemProps = _BreadcrumbItemProps;
    